import { Stack, Typography } from "@mui/material"

export const ViewContactData = ({status, dataContact, billNumber }) => {
    return (
        <Stack direction='row' justifyContent='space-around' pb='1rem' sx={{ borderBottom: '1px solid #1976D2' }}>
            <Stack >
                <Typography variant='h5'><b>Contacto:</b> {dataContact.contactName}</Typography>
                <Typography variant='subtitle1'><b>Teléfono de contacto: </b> {dataContact.contactTel}</Typography>
                <Typography variant='subtitle1'><b>Nº de presupuesto: </b> {billNumber}</Typography>
            </Stack>
            <Stack >
                {status && <Typography variant='h5'><b>Estado:</b> {status}</Typography>}
                <Typography variant='subtitle1'><b>Email:</b> {dataContact.contactEmail}</Typography>
            </Stack>
        </Stack>
    )
}
